import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useClassroomInterruption } from 'Util/Hooks';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';
import CourseGraduateModal from 'Routes/Classroom/Container/CourseGraduateModal';
import CourseReviewModal from 'Routes/Classroom/Container/CourseReviewModal';
import { useConfig } from 'Context/ConfigContext';

import CourseFeedbackImprovementAndSatisfiedPlatformModal from './CourseFeedbackImprovementAndSatisfiedPlatformModal';
import CourseFeedbackImprovementAndSatisfiedContentModal from './CourseFeedbackImprovementAndSatisfiedContentModal';

const ClassroomModal = ({ shouldShowReview }) => {
  const { isInterrupting, activateInterruption, deactivateInterruption } =
    useClassroomInterruption();
  const {
    enableSkooldioCourseReview,
    classroom: { enableGraduateModal },
    feedback = {},
  } = useConfig();

  const enableNPSPlatform = feedback.npsPlatform?.enable;

  const { data } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const { enable: enableNPSContent, progressToShow } = useMemo(() => {
    const npsContentConfigs = feedback.npsContent ?? [];
    const npsContentConfigByProvider = npsContentConfigs.find(
      (feedbackConfig) => feedbackConfig.providerName === data?.myExternalProfile?.providerName
    );
    return npsContentConfigByProvider ?? {};
  }, []);

  return (
    <>
      {/* skooldio modal */}
      {!isInterrupting && enableSkooldioCourseReview && (
        <CourseReviewModal shouldShowReview={shouldShowReview} />
      )}
      {enableGraduateModal && (
        <CourseGraduateModal
          isSwitchedToComplete={shouldShowReview}
          isGraduateModalOpen={isInterrupting}
          onOpenGraduateModal={activateInterruption}
          onCloseGraduateModal={deactivateInterruption}
        />
      )}

      {/* anywhere modal */}
      {enableNPSPlatform && (
        <CourseFeedbackImprovementAndSatisfiedPlatformModal shouldShowReview={shouldShowReview} />
      )}
      {enableNPSContent && (
        <CourseFeedbackImprovementAndSatisfiedContentModal
          shouldShowReview={shouldShowReview}
          progressToShow={progressToShow}
        />
      )}
    </>
  );
};

ClassroomModal.propTypes = {
  shouldShowReview: PropTypes.bool,
};

export default ClassroomModal;
